import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import { callListReportRecords, callListReportRecordsFail, callListReportRecordsSuccess, collectMasterReportRecords, collectMasterReportRecordsFail, collectMasterReportRecordsSuccess, duplicateDossierReportRecords, duplicateDossierReportRecordsFail, duplicateDossierReportRecordsSuccess, duplicateMemberReportRecords, duplicateMemberReportRecordsFail, duplicateMemberReportRecordsSuccess, fetchTermPaymentRecords, fetchTermPaymentRecordsFail, fetchTermPaymentRecordsSuccess } from './report.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { TermPaymentTableService } from './term-payment-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { CollectMasterReportTableService } from './collect-master-report-table.service';
import { CallListReportTableService } from './call-list-report-table.service';
import { DuplicateDossierReportTableService } from './duplicate-dossier-report-table.service';
import { DuplicateMemberReportTableService } from './duplicate-member-report-table.service';

@Injectable()
export class ReportRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchTermPaymentRecords),
            exhaustMap(() => {
                const url = 'report-term-payments'
                return this.crudServerService.fetchTableData(url, this.termPaymentTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.termPaymentTableService.page = data.pagination.current_page;
                        this.termPaymentTableService.lastPage = data.pagination.last_page;
                        this.termPaymentTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.termPaymentTableService.clubs = data.clubs;
                        this.termPaymentTableService.categories = data.categories;

                        this.alertService.triggerAlert(response.message, "success");

                        return fetchTermPaymentRecordsSuccess({termPaymentData: data.records, termPaymentsTotal: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchTermPaymentRecordsFail({ termPaymentError: error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchCollectMasterReportData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(collectMasterReportRecords),
            exhaustMap(() => {
                const url = 'report-collect-master'
                return this.crudServerService.fetchTableData(url, this.collectMasterReportTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.collectMasterReportTableService.page = data.pagination.current_page;
                        this.collectMasterReportTableService.lastPage = data.pagination.last_page;
                        this.collectMasterReportTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.collectMasterReportTableService.clubs = data.clubs;
                        this.collectMasterReportTableService.categories = data.categories;

                        this.alertService.triggerAlert(response.message, "success");

                        return collectMasterReportRecordsSuccess({collectMasterReportData: data.records, collectMasterReportTotal: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => collectMasterReportRecordsFail({ collectMasterReportError: error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchcallListReportData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(callListReportRecords),
            exhaustMap(() => {
                const url = 'report-call-list'
                return this.crudServerService.fetchTableData(url, this.callListReportTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.callListReportTableService.page = data.pagination.current_page;
                        this.callListReportTableService.lastPage = data.pagination.last_page;
                        this.callListReportTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.callListReportTableService.clubs = data.clubs;
                        this.callListReportTableService.categories = data.categories;

                        this.alertService.triggerAlert(response.message, "success");

                        return callListReportRecordsSuccess({callListReportData: data.records, callListReportTotal: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => callListReportRecordsFail({ callListReportError: error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchDuplicateDossierReportData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(duplicateDossierReportRecords),
            exhaustMap(() => {
                const url = 'report-duplicate-dossier'
                return this.crudServerService.fetchTableData(url, this.duplicateDossierReportTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.duplicateDossierReportTableService.page = data.pagination.current_page;
                        this.duplicateDossierReportTableService.lastPage = data.pagination.last_page;
                        this.duplicateDossierReportTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.duplicateDossierReportTableService.clubs = data.clubs;
                        this.duplicateDossierReportTableService.categories = data.categories;

                        this.alertService.triggerAlert(response.message, "success");

                        return duplicateDossierReportRecordsSuccess({duplicateDossierReportData: data.records, duplicateDossierReportTotal: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => duplicateDossierReportRecordsFail({ duplicateDossierReportError: error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchDuplicateMemberReportData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(duplicateMemberReportRecords),
            exhaustMap(() => {
                const url = 'report-duplicate-member'
                return this.crudServerService.fetchTableData(url, this.duplicateMemberReportTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.duplicateMemberReportTableService.page = data.pagination.current_page;
                        this.duplicateMemberReportTableService.lastPage = data.pagination.last_page;
                        this.duplicateMemberReportTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.duplicateMemberReportTableService.clubs = data.clubs;
                        this.duplicateMemberReportTableService.categories = data.categories;

                        this.alertService.triggerAlert(response.message, "success");

                        return duplicateMemberReportRecordsSuccess({duplicateMemberReportData: data.records, duplicateMemberReportTotal: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => duplicateMemberReportRecordsFail({ duplicateMemberReportError: error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private termPaymentTableService: TermPaymentTableService,
        private collectMasterReportTableService: CollectMasterReportTableService,
        private callListReportTableService: CallListReportTableService,
        private duplicateDossierReportTableService: DuplicateDossierReportTableService, 
        private duplicateMemberReportTableService: DuplicateMemberReportTableService, 
        private tableService: DatatableService
    ) { }

}